/**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */
//Italian (Italy)
export default {
  'paginated-picker.async-select.clear-selection-button.clear-all-selected-items-button-text': 'Cancella selezione',
  'paginated-picker.async-select.menu-list.error-message.error-message': 'Impossibile recuperare i dati',
  'paginated-picker.async-select.menu-list.error-message.retry-message': 'Clicca per riprovare',
  'paginated-picker.async-select.menu-list.loading-message.loading-message': 'Caricamento in corso...',
  'paginated-picker.async-select.menu-list.show-more-button.show-more-button-text': 'Mostra altro',
  'paginated-picker.async-select.pagination-details.of-total-count': '{itemsCount} di {totalCount}',
  'paginated-picker.async-select.select.no-options-message.no-options-message': 'Nessuna corrispondenza trovata',
  'paginated-picker.async-select.select.option.error-message': 'Impossibile recuperare i dati',
  'paginated-picker.async-select.select.option.retry-message': 'Clicca per riprovare',
  'paginated-picker.async-select.select.search-placeholder': 'Ricerca',
  'paginated-picker.async-select.show-full-list-button.show-full-list-button-text': "Mostra l'elenco completo"
};